"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { LocaleName } from "@/app/i18n/settings";
import { UpdateCompanyLanguage } from "./actions";
function relocalizeRoute(route: `/${LocaleName}/${string}`, lng: LocaleName) {
  const segments = route.replace(/\/(de|es|en)(\/|$)/, "");
  return `/${lng}/${segments}` as `/${LocaleName}/${string}`;
}
type LngProps<T> = T & {
  lng: LocaleName;
};
export function NavbarLanguageSwitcher(t0) {
  const $ = _c(19);
  const {
    lng
  } = t0;
  const pathname = usePathname() as `/${LocaleName}/${string}`;
  const t1 = `p-1 ${lng === "de" ? "font-bold" : ""} text-secondary`;
  let t2;
  if ($[0] !== pathname) {
    t2 = relocalizeRoute(pathname, "de");
    $[0] = pathname;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <Link className={t1} href={t2} onClick={_temp}>de</Link>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = `p-1 ${lng === "en" ? "font-bold" : ""} text-secondary`;
  let t5;
  if ($[5] !== pathname) {
    t5 = relocalizeRoute(pathname, "en");
    $[5] = pathname;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <Link className={t4} href={t5} onClick={_temp2}>en</Link>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = `p-1 ${lng === "es" ? "font-bold" : ""} text-secondary`;
  let t8;
  if ($[10] !== pathname) {
    t8 = relocalizeRoute(pathname, "es");
    $[10] = pathname;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t7 || $[13] !== t8) {
    t9 = <Link className={t7} href={t8} onClick={_temp3}>es</Link>;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t3 || $[16] !== t6 || $[17] !== t9) {
    t10 = <div className="p-4 pb-0 text-right">{t3}|{t6}|{t9}</div>;
    $[15] = t3;
    $[16] = t6;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
}
async function _temp3() {
  return await UpdateCompanyLanguage("es");
}
async function _temp2() {
  return await UpdateCompanyLanguage("en");
}
async function _temp() {
  return await UpdateCompanyLanguage("de");
}